import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import FormHelperText from '@mui/material/FormHelperText'
import { GeocodeApiResource } from '../../models/GeocodeDTO.model'
import FlowfeedApiQueryService from '../../services/FlowfeedApiQueryService/FlowfeedApiQueryService'

export type GoogleMapsFetchDialogProps = {
  open: boolean
  onClose: () => void
  onFetch: (data: GeocodeApiResource) => void
  dialogTitle: string
}

const GoogleMapsFetchDialog = ({ open, onClose, onFetch, dialogTitle }: GoogleMapsFetchDialogProps) => {
  const [url, setUrl] = useState('')
  const [isFetching, setIsFetching] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleFetch = async () => {
    setIsFetching(true)
    setError(null)
    try {
      const api = new FlowfeedApiQueryService()
      const data = await api.get<GeocodeApiResource>({
        endpoint: '/geocode/get',
        params: { googleMapsUrl: url },
      })
      onFetch(data)
      setUrl('')
      onClose()
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unknown error')
    } finally {
      setIsFetching(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Google Maps URL"
          type="url"
          fullWidth
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          disabled={isFetching}
          placeholder="Paste Google Maps link here"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !isFetching && url) {
              e.preventDefault()
              handleFetch()
            }
          }}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isFetching}>
          Cancel
        </Button>
        <Button onClick={handleFetch} disabled={isFetching || !url} variant="contained">
          {isFetching ? 'Fetching...' : 'Fetch'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default GoogleMapsFetchDialog
